import { createContext, useContext } from 'react';

export const createAsyncDependenciesContext = <AsyncDependencies>() => {
    // Context to share the AsyncDependencies with children through useAsyncDependencies()
    const AsyncDependenciesContext = createContext<AsyncDependencies | undefined>(undefined);

    return {
        Provider: AsyncDependenciesContext.Provider,
        consumer: () => useContext(AsyncDependenciesContext),
    };
};
